<template>
  <div class="page-container">
    <portal to="page-name">Caixa</portal>
    <div class="card card-page" v-if="hasAccess">
      <div class="card-header">
        <h1 class="card-title">Crédito de paciente</h1>
      </div>
      <div class="card-body" v-if="loading">
        <div class="loading"></div>
      </div>
      <div class="card-body" v-else-if="openedCashiers.length > 0">
        <patient-credit-form :cashiers="openedCashiers" @saved="onSaved" />
      </div>
      <div class="card-body" v-else>
        <div class="empty mt-2">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
          </div>
          <p class="empty-title h5">Nenhum caixa aberto</p>
          <p class="empty-subtitle">
            Para realizar a abertura do caixa selecione a opção "Abertura" do menu
          </p>
        </div>
      </div>
    </div>
    <forbidden v-else></forbidden>
  </div>
</template>

<script>
import { CREATE_PATIENT_CREDIT } from '@/data/actions/modules/financial';
import Forbidden from '@/components/auth/Forbidden.vue';
import PatientCreditForm from '../../patient-credit/components/Form.vue';

export default {
  components: {
    Forbidden,
    PatientCreditForm,
  },
  data() {
    return {
      loading: false,
      cashierSettings: [],
      openedCashiers: [],
    };
  },
  computed: {
    hasAccess() {
      return this.$can(CREATE_PATIENT_CREDIT);
    },
  },
  async mounted() {
    if (this.hasAccess) {
      this.loading = true;
      await this.getCashiers();
      await this.getOpenCashiers();
      this.loading = false;
    }
  },
  methods: {
    async getCashiers() {
      await this.$http.get('/cashiers/accounts')
        .then(({ data }) => {
          this.cashierSettings = data.items.map(cashier => ({
            // eslint-disable-next-line no-underscore-dangle
            id: cashier.bankAccount._id,
            name: cashier.bankAccount.name,
            categories: cashier.categories,
          }));
        })
        .catch(() => {});
    },
    async getOpenCashiers() {
      const params = { limit: 0 };
      await this.$http.get('/cashiers?status=open', { params })
        .then(({ data }) => {
          this.openedCashiers = data.items
            .map((openCashier) => {
              const cashier = this.cashierSettings
                .find(item => openCashier.bankAccount.id === item.id);
              if (cashier) {
                openCashier.categories = cashier.categories;
                openCashier.enabled = true;
              } else {
                openCashier.enabled = false;
              }
              return openCashier;
            })
            .filter(openCashier => openCashier.enabled === true);
        })
        .catch(() => {});
    },
    onSaved() {
      this.getOpenCashiers();
    },
  },
};
</script>
